<ng-container *ngTemplateOutlet="(selectTmp === 'btnTmp') ? btnTmp : linkTmp"></ng-container>

<ng-template #btnTmp>
  <button class="o_button_theme_button"
  title="{{((isCollected) ? 'cancelCollect' : 'collect') | translate}}{{title || ''}}"
  [attr.aria-label]="((isCollected) ? 'cancelCollect' : 'collect') | translate"
  attr.aria-pressed="{{isCollected}}"
  [class.disabled]="disabled" [attr.aria-disabled]="lock.isLock"
  [tabindex]="disabled || lock.isLock ? -1 : 0"
  appLock #lock="lock" (click)="toggleCollect()">
    <!-- 已收藏 -->
    <ng-container *ngIf="isCollected; else elseTmp">
      <span class="b_B_a95ea b_B_d4208 oc_U_28a2b b_E_f6d0a">
        <i class="fa fa-bookmark" aria-hidden="true"></i>
      </span>
    </ng-container>
    <!-- 未收藏 -->
    <ng-template #elseTmp>
      <span class="b_B_a95ea b_B_d4208 oc_U_28a2b b_E_f6d0a">
        <i class="fa fa-bookmark-o" aria-hidden="true"></i>
      </span>
    </ng-template>
  </button>
</ng-template>

<ng-template #linkTmp>
  <a href="javascript:void(0)" role="button" title="{{((isCollected) ? 'cancelCollect' : 'collect') | translate}}{{title || ''}}"
  attr.aria-pressed="{{isCollected}}"
  [class.disabled]="disabled" [attr.aria-disabled]="lock.isLock"
  [tabindex]="disabled || lock.isLock ? -1 : 0"
  appLock #lock="lock" (click)="toggleCollect()">
    <ng-container *ngIf="isCollected; else elseTmp">
      <li class="share">
        <img [src]="(whiteImg) ? '/assets/images/v040/bookmark_w_F.svg' : '/assets/images/v040/bookmark_F.svg'" class="shareicon" alt="" width="100" height="100">
        <span class="sharew">{{'cancelCollect' | translate}}</span>
      </li>
    </ng-container>
    <ng-template #elseTmp>
      <li class="share">
        <img [src]="(whiteImg) ? '/assets/images/v040/bookmark_w.svg' : '/assets/images/v040/bookmark.svg'" class="shareicon" alt="" width="100" height="100">
        <span class="sharew">{{'collect' | translate}}</span>
      </li>
    </ng-template>
  </a>
</ng-template>
